import * as msg from "../../message";
import axios from "axios";
import moment from "moment";
import db from "../../database";

const state = {
  billing: {
    dumuy_customer: "",
    customer: {
      address: "",
      data: "",
      summary: "",
    },
    cart: "",
    hold_bill_count: 0,
    subtotal: "0.00",
    discount: "0.00",
    taxes: "0.00",
    carry_bags: "0.00",
    carry_bag_qty_total: "0",
    total_payable: "0.00",
    total_qty: 0,
    remark: "",
    salesPerson: {
      data: [],
      selected: "",
    },
    pay_balance_deposit: {
      trans_sub_type: "",
      transaction_summary: {},
      customer: {},
      save_payment_data: {},
      print_data: "",
      print_html: "",
    },
    vocher_list: [],
    invoice: {
      data: "",
      summary: "",
      print_url: "",
      print_data: "",
    },
    layBy_Amt: 0,
    order: {
      data: "",
      summary: "",
    },
    return_flow: {
      customer_info: "",
      invoice: "",
      product_list: [],
      remarks: "",
      return_confirm_data: {},
      return_invoice: {},
    },
    refund_mode: false,
    invoice_no: "",
    order_no_hold: "",
    order_no: "",
    billing_mode: "normal",
    on_account: {},
    invoice_details: {
      invoice_no: "",
      amount: "",
    },
  },
  trans_sub_type: "",
  auto_print: 0,
  auto_print_enable: false,
  orderPos: {
    due_date: "",
  },
};

const mutations = {
  setTransactionSubType(state, data) {
    state.trans_sub_type = data;
  },
  updateCusotmerGroup(state, data) {
    state.billing.customer.data.groups = data;
  },
  getPayBalDeposit(state, data) {
    state.billing.pay_balance_deposit.trans_sub_type =
      data.data.trans_sub_type == "Credit-Note"
        ? "Credit-Note"
        : data.data.trans_sub_type == "Refund-CN"
        ? "Refund-CN"
        : "Deposit-DN";
    state.billing.pay_balance_deposit.transaction_summary =
      data.transaction_summary;
    state.billing.pay_balance_deposit.customer = data.customer_info;
    state.billing.pay_balance_deposit.save_payment_data = data.data;
    state.billing.pay_balance_deposit.print_data = data.print_url;
    state.billing.pay_balance_deposit.print_html = data.data.html_data;
  },
  clearPayBalDeposit(state) {
    state.billing.pay_balance_deposit.trans_sub_type = "";
    state.billing.pay_balance_deposit.transaction_summary = {};
    state.billing.pay_balance_deposit.customer = {};
    state.billing.pay_balance_deposit.save_payment_data = {};
    state.billing.pay_balance_deposit.print_data = "";
    state.billing.pay_balance_deposit.print_html = "";
  },
  getOnAccountData(state, data) {
    state.billing.on_account = data;
  },
  setBillingMode(state, data) {
    state.billing.billing_mode = data;
    state.billing.refund_mode = data == "return" ? true : false;
  },
  setRefundMode(state, data) {
    state.billing.refund_mode = data;
  },
  setOfflineUserId(state, data) {
    if (state.billing.customer.data.hasOwnProperty("c_id")) {
      state.billing.customer.data.c_id = data;
    }
  },
  replaceWithOfflineOrderId(state, data) {
    state.billing.order.data.order_id = data;
  },
  setInvoiceIdOffline(state, data) {
    state.billing.invoice_no = data;
  },
  setOrderIdOffline(state, data) {
    state.billing.order_no = data;
  },
  setOrderIdHoldOffline(state, data) {
    state.billing.order_no_hold = data;
  },
  setDummyCustomer(state, data) {
    state.billing.dumuy_customer = data.vendor_login_details;
  },
  saveCartDetails(state, data) {
    state.billing.cart = data;
    state.billing.subtotal = data.sub_total;
    state.billing.discount = data.discount;
    state.billing.taxes = data.tax_total;
    state.billing.carry_bag_qty_total = data.carry_bag_qty_total;
    state.billing.total_payable = data.total;
    state.billing.total_qty = data.cart_qty_total;
  },
  saveHoldBillCount(state, data) {
    state.billing.hold_bill_count = data;
  },
  resetBilling(state) {
    state.billing.customer.data = "";
    state.billing.customer.address = "";
    state.billing.customer.summary = "";
    state.billing.customer.group_settings = "";
    state.billing.customer.customer_group_code = "";
    state.billing.cart = "";
    state.billing.cart = "";
    state.billing.order.data = "";
    state.billing.order.summary = "";
    // state.billing.invoice.data = '';
    // state.billing.invoice.summary = '';
    state.billing.subtotal = "0.00";
    state.billing.discount = "0.00";
    state.billing.taxes = "0.00";
    state.billing.carry_bags = "0.00";
    state.billing.carry_bag_qty_total = "0";
    state.billing.total_payable = "0.00";
    state.billing.total_qty = 0;
    state.billing.layby_amount = 0;
    // state.billing.remark = '';
    state.billing.vocher_list = [];
    state.billing.layBy_Amt = 0;
    state.billing.on_account = {};
    state.orderPos.due_date = "";
    // state.billing.refund_mode = false;
  },
  tagCustomerDetails(state, data) {
    state.billing.customer.data = data.data;
    state.billing.customer.address = data.address;
    state.billing.customer.customer_group_code = data.customer_group_code;
    state.billing.customer.summary = data.summary;
    state.billing.customer.group_settings = data.group_settings;
  },
  removeCustomer(state) {
    state.billing.customer.data = "";
    state.billing.customer.address = "";
    state.billing.customer.customer_group_code = "";
    state.billing.customer.summary = "";
    state.billing.customer.group_settings = "";
  },
  newBilling(state) {
    state.billing.customer.data = "";
    state.billing.customer.address = "";
    state.billing.cart = "";
    state.billing.order.data = "";
    state.billing.order.summary = "";
    state.billing.invoice.data = "";
    state.billing.invoice.summary = "";
    state.billing.invoice.print_url = "";
    state.billing.invoice.print_data = "";
    state.billing.subtotal = "0.00";
    state.billing.discount = "0.00";
    state.billing.taxes = "0.00";
    state.billing.carry_bags = "0.00";
    state.billing.carry_bag_qty_total = "0";
    state.billing.total_payable = "0.00";
    state.billing.total_qty = 0;
    state.billing.remark = "";
    state.billing.layby_amount = 0;
    state.billing.vocher_list = [];
    state.billing.salesPerson.data = [];
    state.billing.salesPerson.selected = "";
    state.billing.layBy_Amt = 0;
    state.billing.refund_mode = false;
    state.orderPos.due_date = "";
  },
  salesPersons(state, data) {
    state.billing.salesPerson.data = data;
  },

  clearReturnData(state) {
    state.billing.return_flow.customer_info = "";
    state.billing.return_flow.invoice = "";
    state.billing.return_flow.remarks = "";
    state.billing.return_flow.product_list = [];
    state.billing.return_flow.return_confirm_data = {};
    state.billing.return_flow.return_invoice = [];
  },
  saveConfirmReturnData(state, data) {
    state.billing.return_flow.return_confirm_data = data;
  },
  saveReturnInvoice(state, data) {
    state.billing.return_flow.return_invoice = data;
  },
  setReturnData(state, data) {
    state.billing.return_flow.customer_info = {
      c_id: data.c_id,
      api_token: data.user_api_token,
      // api_token: data.user_api_token,
      name: data.customer_name,
      mobile: data.mobile,
    };
    state.billing.return_flow.invoice = data.order_id;
    // console.log(data.data);
    // state.return_flow.product_list = data.data;
    data.data.map((item, index) => {
      state.billing.return_flow.product_list.push({
        id: index + 1,
        quantity: item.qty,
        discount: item.product_data.discount,
        product: item.product_data.p_name,
        sale_price: item.product_data.r_price,
        net_price: item.product_data.s_price,
        status: false,
        return_qty: item.return_product_qty,
        return_reason: 0,
        return_list: data.return_reasons,
        selected_qty: 0,
        barcode: item.product_data.barcode,
        applied_offers: item.product_data.offer_data.applied_offers,
        weight_flag: item.product_data.weight_flag,
        batch_id: item.product_data.batch_id,
        serial_id: item.product_data.serial_id,
        unit_mrp: item.product_data.unit_mrp,
      });
    });
    // state.return_flow.return_reason = data.return_reason;
  },

  getTotalPayable(state, total) {
    state.billing.total_payable = total;
  },
  saveOrder(state, data) {
    state.billing.order.data = data.data;
    state.billing.order.summary = data.order_summary;
  },
  setRemarks(state, data) {
    state.billing.remark = data;
  },
  saveInvoice(state, data) {
    state.billing.invoice.data = data.data;
    state.billing.invoice.summary = data.order_summary;
    state.billing.invoice.print_url = data.print_url;
  },
  saveOrderSummay(state, data) {
    state.billing.order.summary = data.order_summary;
  },
  saveLaybyAmount(state, data) {
    state.billing.layBy_Amt = data;
  },
  clearInvoiceData(state) {
    state.billing.invoice.data = "";
    state.billing.invoice.summary = "";
    state.billing.invoice.print_url = "";
    state.billing.invoice.print_data = "";
  },
  saveVoucherList(state, data) {
    state.billing.vocher_list = data;
  },
  clearVoucherList(state) {
    state.billing.vocher_list = [];
  },
  setPrintData(state, data) {
    state.billing.invoice.data.html_data.style = data.style;
    state.billing.invoice.data.html_data.html = data.html;
  },
  setPrintData80(state, data) {
    state.billing.invoice.data.html_data = data;
  },
  setDummyCustomerId(state, data) {
    state.billing.dumuy_customer.c_id = data;
  },
  setInvoiceDetails(state, data) {
    state.billing.invoice_details.invoice_no = data.invoice_no;
    state.billing.invoice_details.amount = data.amount;
  },
  clearInvoiceDetails(state) {
    state.billing.invoice_details.invoice_no = "";
    state.billing.invoice_details.amount = "";
  },
  printMode(state, data) {
    state.auto_print = data;
  },
  setAutoPrint(state, data) {
    state.auto_print_enable = data;
  },
  setOrderDueDate(state, data) {
    state.orderPos.due_date = data;
  },
};

const getters = {
  isCheckout: (state) => {
    let check = true;
    if (state.billing.order.data == "") {
      check = false;
    } else {
      check = true;
    }
    return check;
  },
  getCustomerDetails: (state) => {
    if (state.billing.customer.data != "") {
      return {
        name: state.billing.customer.data.first_name,
        mobile: state.billing.customer.data.mobile,
        email: state.billing.customer.data.email,
      };
    } else {
      return {
        name: state.billing.dumuy_customer.first_name,
        mobile: state.billing.dumuy_customer.mobile,
        email: state.billing.dumuy_customer.email,
      };
    }
  },
  checkIfTransTypeDeposit: (state) => {
    let check = false;
    if (state.billing.order.data.trans_sub_type == "Deposit-DN") check = true;
    return check;
  },
};

const actions = {
  cartDetails({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/cart-details",
        },
        rootGetters["sessions/getCustomerParam"]
      );
      // let postData = {
      //   url: "/cart-details"
      // };
      // data.url = "/cart-details";
      // console.log(data);
      axios
        .post(data.url, data)
        .then((res) => {
          commit("saveCartDetails", res.data);
          commit("saveHoldBillCount", res.data.hold_bill_count);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addToCart({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      if (
        state.billing.dumuy_customer.hasOwnProperty("api_token") == false &&
        state.billing.customer.data == ""
      ) {
        let errorData = {
          msg: msg.SELECT_CUSTOMER,
          btntext: "Continue",
          status: "customer_not_tag",
        };
        commit("notifications/showMessage", errorData, {
          root: true,
        });
        reject(errorData);
      } else {
        axios
          .post(data.url, data)
          .then((res) => {
            // console.log(res.data);
            // dispatch("cartDetails");
            resolve(res);
          })
          .catch((err) => {
            // console.log(err.response.data.status);
            if (err.response.data.status == "redirect_to_store_list") {
              let errorData = {
                msg: msg.LOGIN_REDIRECT,
                btntext: "Login",
                type: "logout",
              };
              commit("notifications/showMessage", errorData, {
                root: true,
              });
            }
            // if (err.response.data.status == 'product_not_found') {
            //   let alertData = {
            //     message: err.response.data.message,
            //     type: 'danger'
            //   };
            //   commit('resetAlert');
            //   commit('showAlert', alertData);
            // }
            // if (err.data.status == redirect_to_store_list)
            reject(err);
          });
      }
    });
  },
  getReturnItem({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/order-details", data)
        .then((res) => {
          commit("clearReturnData");
          commit("setReturnData", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getReturnRequest({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          commit("saveConfirmReturnData", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  confirmReturn({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          commit("saveReturnInvoice", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  cancelBill({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          // console.log(res.data);
          commit("resetBilling");
          dispatch("cartDetails");
          resolve(res);
        })
        .catch((err) => {
          dispatch("notifications/displayMessage", err, {
            root: true,
          });
          reject(err);
        });
    });
  },
  updateToCart({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          // console.log(res.data);
          // dispatch("cartDetails");
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          dispatch("notifications/displayMessage", err, {
            root: true,
          });
          // if (err.data.status == redirect_to_store_list)
          reject(err);
        });
    });
  },
  removeProduct({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          // console.log(res.data);
          // dispatch("cartDetails");
          resolve(res);
        })
        .catch((err) => {
          // console.log(err.response);
          dispatch("notifications/displayMessage", err, {
            root: true,
          });
          // if (err.data.status == redirect_to_store_list)
          reject(err);
        });
    });
  },
  tagCustomer({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          commit("tagCustomerDetails", res.data);
          if (window.location.hash == "#/gift-vouchers") {
            dispatch(
              "giftVoucher/cartDetails",
              {},
              {
                root: true,
              }
            );
          } else {
            if (
              res.data.hasOwnProperty("cart_items") &&
              res.data.cart_items.length == 0
            )
              dispatch("cartDetails");
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  unTagCustomer({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          commit("removeCustomer");
          if (window.location.hash == "#/gift-vouchers")
            dispatch(
              "giftVoucher/cartDetails",
              {},
              {
                root: true,
              }
            );
          else dispatch("cartDetails");
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  holdBill({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          resolve(res);
          dispatch("newBill");
        })
        .catch((err) => {
          console.log(err.response);
          reject(err);
        });
    });
  },
  newBill({ commit }) {
    // return new Promise((resolve, reject) => {
    commit("newBilling");
    // });
  },
  recallBill({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          commit("tagCustomerDetails", res.data);
          // dispatch("cartDetails");
          resolve(res);
        })
        .catch((err) => {
          console.log(err.response);
          reject(err);
        });
    });
  },
  checkOut({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "proceed_to_payment") {
            commit("saveOrder", res.data);
            commit("getTotalPayable", res.data.order_summary.total_payable);
          }
          if (state.trans_sub_type == "order") {
            window.location.replace("#/order-summary/" + data.order_id);
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err.response);
          reject(err);
        });
    });
  },
  saveRemark({ commit }, data) {
    commit("setRemarks", data);
  },
  savePayment({ commit, state, dispatch, getters, rootState }, data) {
    return new Promise((resolve, reject) => {
      if (getters["checkIfTransTypeDeposit"]) {
        data.api_token = state.billing.customer.data.api_token;
        data.type = "account_deposite";
      }
      if (state.billing.order.data.trans_sub_type == "Credit-Note") {
        data.api_token = state.billing.customer.data.api_token;
        data.type = "adhoc_credit_note";
      }
      if (state.billing.order.data.trans_sub_type == "Refund-CN") {
        data.api_token = state.billing.customer.data.api_token;
        data.type = "refund_credit_note";
      }

      if (rootState.giftVoucher.isGvSale) data.url = "/gv/save-payment";

      if (state.billing.order.data.hasOwnProperty("payment_by"))
        data.payment_by = state.billing.order.data.payment_by;

      axios
        .post(data.url, data)
        .then((res) => {
          resolve(res);
          if (
            (res.data.status == "fail" && data.type == "account_deposite") ||
            (res.data.status == "fail" && data.type == "adhoc_credit_note") ||
            (res.data.status == "fail" && data.type == "refund_credit_note")
          ) {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            commit("notifications/showAlert", alertData, {
              root: true,
            });
          }
          if (
            res.data.order_summary.total_payable == 0 ||
            res.data.order_summary.total_payable == "0.00"
          ) {
            if (rootState.giftVoucher.isGvSale)
              commit("giftVoucher/clearCart", null, {
                root: true,
              });

            if (
              (res.data.hasOwnProperty("transaction_type") &&
                res.data.transaction_type == "on_account_deposit") ||
              (res.data.hasOwnProperty("transaction_sub_type") &&
                res.data.transaction_type == "Credit-Note") ||
              (res.data.hasOwnProperty("transaction_sub_type") &&
                res.data.transaction_type == "Refund-CN")
            ) {
              window.location.replace(
                "#/customer-list/" + res.data.customer_info.mobile
              );
              commit("getPayBalDeposit", res.data);
              let redirect = document.createElement("a");
              redirect.href =
                "#/order-summary/" +
                res.data.transaction_summary.transaction_id;
              redirect.click();
            } else if (
              res.data.hasOwnProperty("transaction_type") &&
              res.data.transaction_type == "order-for-order"
            ) {
              if (
                data.hasOwnProperty("payment_by") &&
                res.data.order_summary.total_payable == 0
              ) {
                let redirect = document.createElement("a");
                redirect.href =
                  "#/order-summary/" + state.billing.order.data.order_id;
                redirect.click();
                commit("setTransactionSubType", "order");
                commit("newBilling");
              } else if (!data.hasOwnProperty("payment_by"))
                dispatch("orderCreation");
            } else {
              commit("saveInvoice", res.data);
              commit("getTotalPayable", res.data.order_summary.total_payable);
            }
          } else {
            let alertData = {
              message: "Payment saved successfully",
              type: "success",
            };
            commit("notifications/showAlert", alertData, {
              root: true,
            });
            commit("saveOrderSummay", res.data);
            commit("getTotalPayable", res.data.order_summary.total_payable);
          }
          // commit('resetBilling');
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  saveInvoiceId({ state, rootState }) {
    if (
      rootState.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
      rootState.system.settings.vendor_app_menu.offline.status == 1
    ) {
      let insertData = {
        order_id: "",
        invoice_id: state.billing.invoice_no,
        type: "online",
        v_id: parseInt(rootState.sessions.user.v_id),
        store_id: parseInt(rootState.sessions.user.store_id),
        vu_id: parseInt(rootState.sessions.user.vu_id),
        date: moment(new Date()).format("YYYY-MM-DD"),
        time: moment(new Date()).format("HH:mm:ss"),
        online_order_id: 0,
      };
      db.invoiceId.put(insertData);
    }
  },
  getPriceOverride({ rootGetters, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let postData = {
        barcode: data.pdata.barcode,
        unit_mrp: data.pdata.unit_mrp,
        batch_id: data.pdata.batch_id,
        serial_id: data.pdata.serial_id,
        scan: "TRUE",
        qty: data.pdata.qty,
        change_mrp: parseFloat(data.override_price).toFixed(2),
        override_flag: "1",
        cust_gstin: state.billing.customer.data.hasOwnProperty("gstin")
          ? state.billing.customer.data.gstin
          : "",
        url: "/product-details",
      };
      let post = Object.assign(
        postData,
        rootGetters["sessions/getCustomerParam"]
      );
      axios
        .post(post.url, post)
        .then((res) => {
          dispatch("cartDetails").then(() => {
            resolve(res);
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSalesPersonList({ commit, rootGetters }) {
    let data = rootGetters["sessions/getCustomerParam"];
    let url = "/vendor/get-salesman";

    axios.post(url, data).then((res) => {
      commit("salesPersons", res.data.data);
    });
  },
  sendSMS({ state, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      let postData = Object.assign(
        {
          url: "/send-bill-receipt",
          mobile: data.mobile,
          order_id: data.invoice_id,
          invoice_id: data.invoice_id,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      if (
        state.billing.pay_balance_deposit.hasOwnProperty("trans_sub_type") &&
        state.billing.pay_balance_deposit.trans_sub_type == "Refund-CN"
      )
        postData.type = "account_deposite";

      axios
        .post(postData.url, postData)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  sendEmail({ rootGetters }, data) {
    return new Promise((resolve, reject) => {
      let postData = Object.assign(
        {
          url: "/email-invoice",
          email_id: data.email_id,
          invoice_id: data.invoice_id,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      if (
        state.billing.pay_balance_deposit.hasOwnProperty("trans_sub_type") &&
        state.billing.pay_balance_deposit.trans_sub_type == "Refund-CN"
      )
        postData.type = "account_deposite";

      axios
        .post(postData.url, postData)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  generateEinvoice({ rootGetters, state }) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/einvoice-generate",
          invoice_id: state.billing.invoice.data.invoice_id,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .post(data.url, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  orderCreation({ commit, state, rootGetters }) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          order_id: state.billing.order.data.order_id,
          due_date: state.orderPos.due_date,
          url: "oms/order-creation",
        },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .post(data.url, data)
        .then((res) => {
          if (["success", "order_creation"].includes(res.data.status)) {
            commit("saveInvoice", res.data);
            commit("getTotalPayable", 0);
            commit("setTransactionSubType", "order");
            let redirect = document.createElement("a");
            redirect.href =
              "#/order-summary/" + res.data.data.order_id + "/success";
            redirect.click();
            setTimeout(() => {
              commit("newBilling");
            }, 1000);
          }
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
